// extracted by mini-css-extract-plugin
module.exports = {"container":"_form_container__2peN9","body":"_form_body__3ofpW","footer":"_form_footer__3iWU9"};